import axios from 'axios';

import * as destinations from './destinations';
import * as categories from './categories';
import * as homePage from './homePage';
import * as stories from './stories';
import * as blogs from './blogs';
import * as promocode from './promocode';
import * as activities from './activities';
import * as cart from './cart';
import * as checkout from './checkout';
import * as reviews from './reviews';
import * as orders from './orders';
import * as pages from './pages';
import * as partners from './partners';
import * as itineraries from './itineraries';
import * as images from './images';

export default {
    destinations,
    categories,
    homePage,
    stories,
    blogs,
    promocode,
    activities,
    cart,
    reviews,
    checkout,
    orders,
    pages,
    partners,
    itineraries,
    images,
    CancelToken: axios.CancelToken,
};
